import React, { FC } from 'react'
import classNames from 'classnames'
import componentStyles from './ChatMessage.module.scss'
import { ChatMessageProps } from './types'

const ChatMessage: FC<ChatMessageProps> = ({ author, message, mine }) =>
  <li
    data-bdd='chat-message'
    className={
      classNames({
        [componentStyles['message']]: true,
        [componentStyles['my-message']]: mine
      })
    }
  >
    <b>{author}:</b>{` ${message}`}
  </li>

export default ChatMessage
